<template>
   <v-app id="inspire">
      <v-main>
         <router-view></router-view>
      </v-main>

      <!-- Alert -->
      <Alert></Alert>

      <!-- LoginRequest -->
      <LoginRequest></LoginRequest>

      <!-- Dialog Refresh Token Auth -->
      <TokenRefresh></TokenRefresh>

      <!-- Snackbar -->
      <Snackbar></Snackbar>

      <!-- GeneralMessage -->
      <MessageGeneral></MessageGeneral>
   </v-app>
</template>

<script>
import { EventBus } from "@/main";
import Alert from "@/../../GeneralComponents/Alert";
import Snackbar from "@/../../GeneralComponents/Snackbar";
import LoginRequest from "@/components/Messages/LoginRequest";
import MessageGeneral from "@/components/Messages/General";
import TokenRefresh from "@/../../GeneralComponents/VUEX/TokenRefresh";

export default {
   name: "App",

   components: {
      Alert,
      Snackbar,
      LoginRequest,
      TokenRefresh,
      MessageGeneral,
   },

   data() {
      return {
         ui: {
            geting: true,
         },
      };
   },

   created() {
      this.$store.dispatch("getProducts");

      EventBus.$on("Logout", () => {
         this.$store.dispatch("logout");
      });

      EventBus.$on("AppOverflowToggle", (val) => {
         if (val === true) {
            // document.getElementById("inspire").style.overflowY = "hidden";
         } else {
            // document.getElementById("inspire").style.overflowY = "initial";
         }
      });
   },
};
</script>

<style lang="css">
#inspire {
   width: 100vw;
   padding: 0;
   margin: 0;
}

.v-list-item__mask {
   color: #fff !important;
   background-color: #0078d7 !important;
}

/*Extra small < 600px*/
@media (min-width: 0) and (max-width: 960px) {
   #inspire {
      overflow-x: hidden;
   }
}

.v-data-table tbody tr.v-data-table__expanded__content {
   box-shadow: none !important;
}
</style>
